var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');
require('knockout-postbox');

function LeaveListItem(params, api, parent) {
  this.showInputLeave = ko.observable(false);
  this.AbsenceKey = params.AbsenceKey;
  this.leaveYear = ko.observable(params.Year);
  this.storedLeaveYear = ko.observable(this.leaveYear());
  this.API = api;
  this.parent = parent;
}

LeaveListItem.prototype.toggleChangeLeave = function() {
  this.showInputLeave(!this.showInputLeave());
};

LeaveListItem.prototype.submitChangeLeave = function() {
  this.storedLeaveYear(this.leaveYear());
  this.addOrUpdateLeave();
  this.toggleChangeLeave();
};

LeaveListItem.prototype.cancelChangeLeave = function() {
  this.leaveYear(this.storedLeaveYear());
  this.toggleChangeLeave();
};

LeaveListItem.prototype.askDelete = function() {
  this.parent.openModal(this);
};

LeaveListItem.prototype.deleteAbsence = function() {
  var url = this.API.deleteAbsence + '?key=' + this.AbsenceKey;
  APIHelper.post(
    url,
    null,
    function() {
      ko.postbox.publish('changeInAbsence', {});
    },
    null,
    null
  );

  this.parent.leaveItems.remove(this);
};

LeaveListItem.prototype.addOrUpdateLeave = function(cb) {
  var url = this.API.addOrUpdateAbsence + '?year=' + this.leaveYear();
  if (this.AbsenceKey !== undefined) {
    url += '&key=' + this.AbsenceKey;
  }

  APIHelper.post(
    url,
    null,
    function(absenceKey) {
      if (cb) {
        cb(absenceKey);
      }
    },
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: extended-leave.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    },
    null
  );
};

function ExtendedLeave(params) {
  this.API = params.api;
  this.parent = params.parent;
  this.links = this.parent.links;
  this.absenceLink = params.absenceLink;
  this.activeModal = ko.observable(false);
  this.modalText = ko.observable(
    'Er du sikker på at du vil slette denne permisjonen?'
  );
  this.modalTitle = ko.observable('');
  this.deletableItem = ko.observable();

  this.newLeaveText = ko.observable('');
  this.leaveItems = ko.observableArray([]);

  this.getLeave();
}

ExtendedLeave.prototype.init = function(element) {
  this.$element = $(element);
};

ExtendedLeave.prototype.confirmModal = function() {
  this.closeModal();
  this.deletableItem().deleteAbsence();
};

ExtendedLeave.prototype.openModal = function(item) {
  this.activeModal(true);
  this.deletableItem(item);
};

ExtendedLeave.prototype.closeModal = function() {
  this.activeModal(false);
};

ExtendedLeave.prototype.addLeave = function() {
  var year = parseInt(this.newLeaveText(), 10);
  var newLeave = new LeaveListItem({ Year: year }, this.API, this);
  newLeave.addOrUpdateLeave(
    function(absenceKey) {
      if (absenceKey > 0) {
        newLeave.AbsenceKey = absenceKey;
        this.leaveItems.push(newLeave);
        ko.postbox.publish('changeInAbsence', {});
      } else {
        // TODO: Give an error message if we did not receive an absenceKey.
      }
    }.bind(this)
  );
};

ExtendedLeave.prototype.getLeave = function() {
  APIHelper.get(
    this.API.getAbsence,
    function(response) {
      for (var i = 0; i < response.length; i++) {
        this.leaveItems.push(new LeaveListItem(response[i], this.API, this));
      }
    }.bind(this)
  );
};

module.exports = ExtendedLeave;
